export class WorkflowApplicationRoutingDetails {
  submitterId?: string;
  clientId?: string;
  departmentId?: string;
  useNewLayout?: boolean;
  applicationId: string;

  constructor(options?: Partial<WorkflowApplicationRoutingDetails>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
